import { useContext } from 'react';
import { FileContext } from '../context/FileContext';

const COLOR_CODES = [
  '#FFC804',
  '#8F6FB3',
  '#C46B8F',
  '#F6686D',
  '#4F73DE',
  '#4ADE80',
  '#2DD4BF',
  '#38BDF8',
  '#E879F9',
  '#9D37EE',
];

// this maps color with 0.4% opacity
export const rgbMapper = {
  '#FFC804': '#FFE9AE',
  '#8F6FB3': '#D2C6E1',
  '#C46B8F': '#E9C5D3',
  '#F6686D': '#FEC4C5',
  '#4F73DE': '#B9C7F3',
  '#4ADE80': '#BEF2CD',
  '#2DD4BF': '#B8EFE5',
  '#38BDF8': '#B7E5FD',
  '#E879F9': '#F7CAFD',
  '#9D37EE': '#DAB0FA',
};

export function useColumnOrder() {
  const { signersSettings, setSignersSettings } = useContext(FileContext);
  let signersList = signersSettings?.signers;

  // from assign column dropdown
  const updateSignersSettings = (signer) => {
    const selectedSigner = signersList?.find(
      (x) => x.emailColumnId === signer.value,
    );
    if (selectedSigner) return;

    const newSigner = {
      label: signer.label,
      emailColumnId: signer.value,
      color: signer.color,
      ...(signer.userId ? {} : { type: signer.type }),
      ...(signer.userId ? { userId: signer.userId } : {}),
    };
    signersList?.push(newSigner);
    setSignersSettings({ ...signersSettings, signers: signersList });
  };

  // from ordering modal
  const handleCheckboxClick = (e) => {
    setSignersSettings({
      ...signersSettings,
      isSigningOrderRequired: e.target.checked,
    });
  };

  // from ordering modal
  const handleDragOrder = (value) => {
    setSignersSettings({
      ...signersSettings,
      signers: value,
    });
  };
  function mapColor(color) {
    return rgbMapper[color] || color;
  }
  return {
    rgbMapper,
    signersSettings,
    COLOR_CODES,
    updateSignersSettings,
    handleCheckboxClick,
    handleDragOrder,
    mapColor,
  };
}
